/* LIT premium layer: fold supplier specs and size tables, hide empty review widgets */
(function () {
  function foldSpecs() {
    document.querySelectorAll('.product-details rte-formatter, .product-details .rte').forEach(function (rte) {
      if (rte.querySelector('.lit-specs')) return;
      var kids = Array.prototype.slice.call(rte.children);
      var start = kids.findIndex(function (el) {
        var t = el.textContent.trim();
        return /^(Item Number|Size Chart)/i.test(t) || el.matches('table, .rte-table-wrapper');
      });
      if (start < 0) return;
      var details = document.createElement('details');
      details.className = 'lit-specs';
      var summary = document.createElement('summary');
      summary.textContent = 'Specs & size chart';
      details.appendChild(summary);
      kids.slice(start).forEach(function (el) { details.appendChild(el); });
      rte.appendChild(details);
    });
  }

  function hideEmptyReviews() {
    document.querySelectorAll('.jdgm-rev-snippet-widget-v2, .jdgm-horizon-widget, .jdgm-widget').forEach(function (w) {
      var text = w.textContent.replace(/\s+/g, ' ').trim();
      if (text && !/Be the first to write a review/i.test(text)) return;
      if (w.closest('[id*="cart-drawer"], cart-drawer, .cart-drawer')) return;
      (w.closest('.shopify-section') || w).classList.add('lit-empty-reviews');
    });
  }

  function run() { foldSpecs(); hideEmptyReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  // Judge.me renders late
  setTimeout(hideEmptyReviews, 2500);
  setTimeout(hideEmptyReviews, 6000);
})();

/* LIT motion layer: staggered reveal of section content and product cards */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && Shopify.designMode) return; // keep the editor static

  var SEL = [
    'main .shopify-section h1', 'main .shopify-section h2', 'main .shopify-section h3',
    'main .shopify-section p', 'main .shopify-section .button',
    'main product-card', 'main .product-card', 'main .resource-list__item',
    'main .shopify-section img:not(header img)', 'main .shopify-section video'
  ].join(',');

  function mark(root) {
    var groups = new Map();
    root.querySelectorAll(SEL).forEach(function (el) {
      if (el.closest('[data-lit-reveal]') || el.closest('header, footer, dialog, .drawer')) return;
      // only reveal what starts below the first screen, so the hero is never delayed
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      var sec = el.closest('.shopify-section') || root;
      var i = groups.get(sec) || 0;
      groups.set(sec, i + 1);
      el.setAttribute('data-lit-reveal', '');
      el.style.setProperty('--lit-i', Math.min(i, 6));
      io.observe(el);
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });

  document.documentElement.classList.add('lit-motion');
  function start() { mark(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  // Safety net: never leave content hidden
  setTimeout(function () {
    document.querySelectorAll('[data-lit-reveal]').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
    });
  }, 2500);
})();
